<template>
	<div class="page">
		<!-- 顶部 Logo 区域 -->
		<div class="logo">
			<img src="../assets/images/logo/logo2.png" alt="logo" />
		</div>

		<!-- 中间会议邀请信息卡片（由代码绘制文案，不再使用整图） -->
		<div class="info-card">
			<p class="info-paragraph">
				尊敬的嘉宾朋友们:<br />
				中国联通湖北省分公司将于2026年7月23日上午，隆重举办科技创新暨合作伙伴大会。本次大会以"AI为先智创未来"为主题，坚持AI为先，集中展示科技创新成果，共建产业合作生态。
			</p>
			<p class="info-paragraph">
				诚挚邀您共同见证中国联通湖北省分公司以科技创新赋能千行百业，携手共创数智湖北新篇章! 相关事宜如下：
			</p>

			<div class="info-section">
				<div class="info-section-title">一、会议安排</div>
				<ul class="info-list">
					<li>会议日期：2026年7月23日</li>
					<li>签到入场：08:00—08:30</li>
					<li>会议时间：08:30—11:25</li>
					<!-- <li>自助午餐：11:00—13:00</li> -->
				</ul>
			</div>

			<div class="info-section">
				<div class="info-section-title">二、会议地点</div>
				<ul class="info-list">
					<li>武汉富力万达嘉华酒店（三楼大宴会厅）</li>
					<li>地址：武汉市武昌区东湖路105号</li>
					<li>自助餐厅：酒店一楼美食汇全日餐厅</li>
				</ul>
			</div>

			<!-- <div class="info-section">
				<div class="info-section-title">三、参会人员</div>
				<ul class="info-list">
					<li>贵司总经理或副总经理</li>
				</ul>
			</div> -->

			<div class="info-section">
				<div class="info-section-title">四、食宿安排</div>
				<ul class="info-list">
					<!-- <li>本次会议不收取费用；</li> -->
					<li>住宿自理；</li>
					<li>会议当天安排自助午餐。</li>
				</ul>
			</div>

			<!-- <p class="info-paragraph">
				如有疑问，请联系对应的采购工程师。
			</p> -->

			<div class="info-footer">
				<div>中国联通湖北省分公司</div>
				<!-- <div>采购部谨邀</div> -->
				<div>2026年7月</div>
			</div>
		</div>

		<!-- 我要报名按钮：2026年3月20日12:00 起隐藏 -->
		<div v-if="showApplyButton" class="apply" @click="toApply">我要报名</div>

		<!-- 右侧温馨提示入口 -->
		<div class="tips" @click="toTip">
			<img src="../assets/images/index-tip.png" alt="温馨提示" />
		</div>
	</div>
	<BottomNav />
</template>

<script setup>
import BottomNav from "../components/BottomNav.vue";
import { computed } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

/** 当前时间早于 2026-03-20 12:00 时显示报名按钮，之后隐藏 */
const showApplyButton = computed(() => {
	const now = new Date();
	const hideFrom = new Date(2026, 2, 20, 12, 0, 0, 0); // 月 2 = 三月
	return now < hideFrom;
});

// 跳转报名页面
const toApply = () => {
	router.push({
		path: "/apply",
		query: {},
	});
};

// 跳转温馨提示页面
const toTip = () => {
	router.push({
		path: "/tip",
		query: {},
	});
};
</script>

<style scoped>
.page {
	width: 100vw;
	background: url("../assets/bg/718.jpg") 100% 100% no-repeat;
	background-size: cover;
	display: flex;
	flex-direction: column;
	align-items: center;
	box-sizing: border-box;
	padding-top: 20px;
    height: calc(100vh - 50px);

}

.logo img {
	width: 40%;
	height: auto;
	display: block;
    margin: auto;
	padding: 10px 0;
    box-sizing: border-box;
}


.info-card {
	width: 88%;
	margin-top: 10px;
	border-radius: 16px;
	padding: 16px 14px 20px;
    /* 从上到下：亮蓝 → 半透深蓝 */
    background: linear-gradient(180deg, #00b4ff, rgba(0, 123, 255, 0.3));
	/* background-color: rgba(2, 174, 250, 0.2); */
	/* color: #ffffff; */
	color: #ffffff;
	font-size: 13px;
	line-height: 1.6;
	box-sizing: border-box;
	text-align: left;
}

.info-paragraph {
	margin: 4px 0 8px;
}

.info-section {
	margin-top: 10px;
}

.info-section-title {
	display: inline-block;
	padding: 2px 10px;
	margin-bottom: 4px;
	background: linear-gradient(90deg, #00b4ff, #007bff);
	border-radius: 12px;
	font-size: 10px;
}

.info-list {
	margin: 0;
	padding: 0;
	list-style: none;
}

.info-list li::before {
	content: "●";
	display: inline-block;
	width: 1em;
	margin-right: 4px;
	color: #ffffff;
}

.info-footer {
	margin-top: 16px;
	text-align: right;
	font-size: 13px;
}

.apply {
	width: 160px;
	height: 40px;
	margin-top: 24px;
	background-image: url("../assets/images/apply.png");
	background-size: 100% 100%;
	background-position: center;
	background-repeat: no-repeat;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #0175ff;
	font-size: 16px;
	font-weight: 600;
}

.tips {
	position: fixed;
	right: 0;
	bottom: 100px;
}

.tips img {
	height: 90px;
	width: auto;
	display: block;
}
</style>
